"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var financeAndInsuranceStyles = makeStyles_1.default(function (theme) {
    var _a, _b;
    return ({
        container: {
            padding: '20px 0',
        },
        imageRoot: (_a = {
                padding: 0
            },
            _a[theme.breakpoints.up('lg')] = {
                margin: '0 0 30px 0',
            },
            _a[theme.breakpoints.down('sm')] = {
                margin: '0 auto',
            },
            _a),
        image: {
            marginBottom: '10px',
            objectFit: 'contain',
        },
        details: {
            marginBottom: '15px',
            fontFamily: theme.typography.fontFamily,
        },
        summaryLabel: {
            fontWeight: 900,
        },
        buttonsWrapper: (_b = {
                display: 'flex'
            },
            _b[theme.breakpoints.down('xs')] = {
                alignItems: 'center',
                flexDirection: 'column',
            },
            _b),
        financeDetails: {},
    });
}, { name: 'Checkout4_FinanceAndInsurance' });
exports.default = financeAndInsuranceStyles;
